<template>
  <Modal class="newsModal" :title="title" :isOpen="isOpen" @close="close()" @callbackBtn1="close()" :buttons="buttonData">
    <template #icon>
      <img src="@/assets/images/img/rocket.png" alt="icon" class="icon" />
    </template>
    <template v-if="!!videoUrl" #video>
      <div class="text" v-safe-html="text" />
      <div class="video-wrapper">
        <iframe
          :src="videoUrl"
          frameborder="0"
          allowfullscreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        ></iframe>
      </div>
    </template>
    <template #extra>
      <div v-if="!video" class="text" v-safe-html="text" />
      <div class="dontShowAgain">
        <input type="checkbox" id="dontShowAgain" v-model="dontShowAgain" />
        <label for="dontShowAgain" class="ml-2">
          {{ $t("app.modals.newsModal.doNotShowCheckbox") }}
        </label>
      </div>
    </template>
  </Modal>
</template>

<style lang="scss" scoped>
.newsModal {
  line-height: normal;

  :deep(.modal-body) {
    @media screen and (max-width: 767px) {
      padding-bottom: 16px !important;
    }
  }

  .video-wrapper {
    position: relative;
    margin-left: auto;
    margin-right: auto;
    margin-top: 32px;
    width: 400px;
    height: 225px;
    overflow: hidden;
    border-radius: 12px;
  }

  .video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .icon {
    margin: 0 auto;

    width: 88px;
    height: 88px;
  }

  :deep(h2) {
    max-width: 100% !important;
    margin: 32px 0 !important;

    text-align: center;
    font-size: 26px;
    line-height: normal;
  }

  .dontShowAgain {
    display: flex;
    margin-top: 32px;

    input {
      margin-right: 8px;
    }
  }
}
</style>

<script setup>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { setLocale } from "@/i18n/index.js";
import YouTube from 'vue3-youtube';

const i18n = useI18n({ useScope: "global" });

const { isOpen, title, text, video } = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
  },
  text: {
    type: String,
  },
  video: {
    type: String,
    required: false,
  }
});

const emits = defineEmits(["close"]);

const dontShowAgain = ref(false);
let videoUrl = ref(undefined);

const buttonData = {
  column: true,
  data: [
    {
      label: i18n.t('app.modals.newsModal.gotItButton'),
      class: 'primary',
    },
  ],
};


watch(
  () => video,
  (newVideo, oldVideo) => {
    if (!videoUrl.value && newVideo?.length) {
      const videoId = newVideo.split('v=')[1];
      videoUrl.value = `https://www.youtube.com/embed/${videoId}?controls=1`;
    }
  }
);

onBeforeMount(() => {
  if (video?.length) {
      const videoId = video.split('v=')[1];
      videoUrl.value = `https://www.youtube.com/embed/${videoId}?controls=1`;
    }
})

function close() {
  // Pass the dontShowAgain value when closing
  emits("close", dontShowAgain.value);
}

</script>